import { getSystemMenu } from '@/api/common/index'
import { traversalMenu } from '@/utils/utils.js'
import { systemId } from '@/config/index'

const systemPower = {
  state: {
    systemlist: [], // 系统列表
    menus: [], // 系统菜单列表
    tagsViews: [],
    power: {},
    userName: ''
  },
  mutations: {
    updatasystemlist (state, data) {
      state.systemlist = data
    },
    updataPower (state, data) {
      state.power = data
    },
    updataMenus (state, data) {
      state.menus = data
    },
    updateUserName (state, data) {
      state.userName = data
    },
    updateTagsView (state, data) {
      state.tagsViews = null
      state.tagsViews = data
    }
  },
  getters: {
    systemlist: state => state.systemlist,
    power: state => state.power,
    menus: state => state.menus,
    userName: state => state.userName,
    tagsViews: state => state.tagsViews
  },
  actions: {
    getMenuList ({ commit }) {
      return new Promise((resolve, reject) => {
        getSystemMenu({
          systemId: systemId
        }).then(response => {
          if (response.mobBaseRes.code === 100) {
            const obj = traversalMenu(response.mobBaseRes.datas || [])
            const list = obj.url
            const power = obj.power
            commit('updatasystemlist', list)
            commit('updataPower', power)
            commit('updataMenus', response.mobBaseRes.datas)
            window.sessionStorage.power = JSON.stringify(power)
          }
          resolve(response)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}

export default systemPower
